import type { ImgHTMLAttributes } from "react";

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    webp?: string;
}

/**
 * Image with automatic WebP source. `webp` defaults to `src` with the extension swapped.
 * The `<img>` keeps all original props (className, alt, sizing, loading, etc.).
 */
export default function Image({ src, webp, ...rest }: ImageProps) {
    const webpSrc = webp ?? src.replace(/\.(png|jpe?g)$/i, ".webp");
    return (
        <picture>
            <source srcSet={webpSrc} type="image/webp" />
            <img src={src} {...rest} />
        </picture>
    );
}
